/* unplugin-vue-components disabled */import { render } from "./AccountCreationNotificationDialog.vue?vue&type=template&id=d9456f88&scoped=true&ts=true"
import script from "./AccountCreationNotificationDialog.vue?vue&type=script&lang=ts"
export * from "./AccountCreationNotificationDialog.vue?vue&type=script&lang=ts"

import "./AccountCreationNotificationDialog.vue?vue&type=style&index=0&id=d9456f88&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9456f88"]])

export default __exports__